import PropTypes from 'prop-types'
import { useState } from 'react'

import { convertDate } from 'lib/dates'
import Text from 'components/Text'
import Image from 'components/Image'

import BarChart from './ChartBar'
import Tabs from './Tabs'

const styles = {
    wrapper: {
        background: '#fff',
        // boxShadow: '0px 0px 10px rgba(205, 213, 231, 0.4)',
        // border: '1px solid #EBF0F9',
        paddingBottom: 15,
        paddingTop: 15,
        borderRadius: 15,
        boxShadow: '0px 0px 25px rgba(205, 213, 231, 0.3)',
    },
    postsImageWrapper: {
        marginTop: 10,
        display: 'flex',
        justifyContent: 'space-around',
        paddingLeft: 43,
        paddingRight: 5,
        overflow: 'hidden',
    },
    imageWrapper: {
        height: 80,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    title: {
        marginLeft: 15,
    },
    date: {
        fontSize: 12,
        marginTop: 5,
        transform: 'rotate(90deg)',
        width: 0,
        whiteSpace: 'nowrap',
        color: '#BCC6D9',
    },
}
const PostComparisons = ({ posts, tabs }) => {
    const [ activeTab, setActiveTab ] = useState(tabs[0] && tabs[0].key)

    return (
        <div style={styles.wrapper}>
            <div style={styles.title}>
                <Text
                    children={`This post vs last ${posts.length} posts`}
                    size={'h6'}
                    weight={'bold'}
                />
            </div>
            <div style={{ height: 30 }}/>
            <Tabs
                tabs={tabs}
                setActiveTab={setActiveTab}
                activeTab={activeTab}
            />
            <div style={{ height: 30 }}/>
            <BarChart data={posts} dataKey={activeTab} hideDate />
            <div style={styles.postsImageWrapper}>
                {posts.map(item => {
                    return (
                        <div
                            key={item.id}
                            style={{
                                ...styles.imageWrapper,
                            }}>
                            <Image
                                height={26}
                                width={26}
                                src={item.pic}
                                borderRadius={5}
                                objectFit={'cover'}
                                fallbackType={'contentV1'}
                            />
                            <span
                                style={styles.date}
                                children={convertDate(item.date)}/>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

PostComparisons.propTypes = {
    posts: PropTypes.arrayOf(PropTypes.shape({
        views: PropTypes.number,
        comments: PropTypes.number,
        likes: PropTypes.number,
    })),
    tabs: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string,
        label: PropTypes.string,
    })),
}

PostComparisons.defaultProps = {
    posts: [],
    tabs: [],
}

export default PostComparisons
